{
  "feeGrid": {
    "defaultFeeGridFor": "Tabla de comisiones por impago para",
    "default": {
      "feeGridOrg": "Organización de la tabla de tarifas: {{org}}",
      "defaultName": "Nombre de la tabla de tarifas: {{name}}",
      "defaultType": "Tipo de tabla de tarifas: ",
      "parentDefault": "Predeterminado"
    },
    "table": {
      "name": "Nombre",
      "type": "Tipo",
      "default": "Predeterminado",
      "state": "Estado",
      "active": "Activo",
      "inactive": "Inactivo",
      "flat": "Plano",
      "blendedGrid": "Por niveles - Mixto",
      "volumeGrid": "Por niveles - Volumen",
      "organization": "Organización"
    },
    "delete": {
      "confirmationTitle": "Eliminar tabla de tarifas",
      "confirmationMessage": "¿Está seguro de que desea eliminar esta tabla de tarifas?"
    },
    "edit": {
      "title": "Actualizar tabla de tarifas",
      "updatedToastMessage": "Se ha actualizado la tabla de tarifas.",
      "deletedToastMessage": "La tabla de tarifas ha sido eliminada.",
      "name": "Nombre",
      "type": {
        "label": "Tipo",
        "tooltip": "Plano: se aplicará la tarifa especificada independientemente del AUM facturable.\nPor niveles: se aplicarán tarifas específicas a los diferentes niveles de AUM facturable.",
        "flat": "Plano",
        "tiered": "Por niveles"
      },
      "flatAnnualFeeBpsLabel": "Cuota anual fija BPS",
      "grid": {
        "to": "a",
        "minAmount": "Mínimo",
        "maxAmount": "Máximo",
        "above": "Arriba",
        "annualFeeBps": "Cuota anual BPS",
        "annualFeeCents": "Cuota anual",
        "type": {
          "label": "Tipo de red",
          "tooltip": "Tabla de comisiones combinadas: los diferentes niveles de activos se cobran según sus propias tarifas específicas. Por ejemplo, el primer millón de dólares se cobra al 1,5 % y los fondos entre 1 y 2 millones de dólares se cobran al 1,25 %.\n Tabla de comisiones por volumen: las comisiones de toda su cartera se cobran a una tasa determinada. Por ejemplo, si tiene menos de 1 millón de dólares, su comisión podría ser del 1,5 %, pero si su cartera está entre 1 y 2 millones de dólares, podría pagar una comisión del 1,25 % por todos los fondos.",
          "blended": "Mezclado",
          "volume": "Volumen"
        }
      },
      "chargeForCash": {
        "label": "Saldo de efectivo incluido en los activos gestionados facturables"
      },
      "chargeForCashOnHold": {
        "label": "El saldo en efectivo retenido se incluye en los activos gestionados facturables"
      },
      "default": {
        "label": "Tabla de comisiones por incumplimiento",
        "tooltip": "Esta tabla de tarifas se aplicará automáticamente a un hogar o cliente si no se ha establecido ninguna tabla de tarifas. Solo puede haber una tabla de tarifas predeterminada.",
        "defaultFlagTooltip": "Solo puede haber una tabla de tarifas predeterminadas activa. Elimine la marca predeterminada de la tabla de tarifas predeterminadas activa existente."
      },
      "gridScope": {
        "label": "Calcular los activos gestionados facturables basándose en",
        "tooltip": "Si una subcuenta no forma parte de la agrupación seleccionada, la facturación recurre a la siguiente estrategia de agrupación inferior: Grupo de cuentas → Hogar → Usuario."
      },
      "billableAumInclude": {
        "title": "Inclusión de activos gestionados facturables"
      }
    },
    "new": {
      "title": "Nueva tabla de tarifas",
      "createdToastMessage": "Se ha creado la tabla de tarifas."
    },
    "inherited": "Heredado (predeterminado de la organización)",
    "inheritedWithFeeTier": "Heredado ({{applicableFeeTier}})",
    "inheritedWithApplicableBillingSchedule": "Heredado ({{applicableBillingSchedule}})",
    "errors": {
      "noDefaultFound": "No se encontró ninguna tabla de tarifas predeterminada. Por favor, seleccione una.",
      "multipleDefaultsFound": "Se encontraron varias tablas de tarifas predeterminadas ({{grid_names}}). Por favor, seleccione solo una."
    },
    "gridScopeType": {
      "USER": "Usuario",
      "CLIENT_GROUP": "Hogar",
      "ACCOUNT_GROUP": "Grupo de cuentas",
      "SUB_ACCOUNT": "Subcuenta"
    }
  },
  "billingCycle": {
    "startDate": "Fecha de inicio",
    "endDate": "Fecha de finalización",
    "billingDate": "Fecha de facturación",
    "calculationDate": "Fecha de cálculo",
    "collectedFees": "Tarifas cobradas",
    "projectedFeeAndTax": "Tasas e impuestos previstos",
    "totalFeesAndTax": "Total de tasas e impuestos",
    "organization": "Organización",
    "billableAumLastDay": "Activos gestionados facturables el último día",
    "billableAumWithReductionsApplied": "Reducciones aplicadas",
    "accruedFees": "Honorarios devengados",
    "salesTax": "Impuesto sobre las ventas",
    "state": "Estado",
    "PROCESSED": "Procesado",
    "APPROVED": "Aprobado",
    "AWAITING_REVIEW": "Revisión",
    "CYCLE_IN_PROGRESS": "Ciclo en curso",
    "CYCLE_COMPLETED": "Ciclo completado",
    "baseCurrency": "Moneda"
  },
  "billingSchedule": {
    "defaultBillingScheduleFor": "Calendario de facturación predeterminado para",
    "default": {
      "billingScheduleOrg": "Organización del calendario de facturación: {{org}}",
      "defaultFrequency": "Repeticiones: {{frequency}}",
      "parentNextCalculationDate": "Próxima fecha de cálculo: {{nextCalculationDate}}",
      "parentNextBillingDate": "Próxima fecha de facturación: {{nextBillingDate}}",
      "parentDefault": "Predeterminado"
    },
    "table": {
      "frequency": "Repeticiones",
      "default": "Predeterminado",
      "state": "Estado",
      "nextCycle": "Próximo ciclo de facturación",
      "nextCalculationDate": "Próxima fecha de cálculo",
      "nextBillingDate": "Próxima fecha de facturación",
      "active": "Activo",
      "inactive": "Inactivo",
      "organization": "Organización"
    },
    "edit": {
      "title": "Actualizar calendario de facturación",
      "updatedToastMessage": "Se ha actualizado el calendario de facturación.",
      "deletedToastMessage": "Se ha eliminado el calendario de facturación.",
      "frequency": "Frecuencia",
      "frequencyLabel": "Calcular las tarifas cada",
      "default": {
        "label": "Calendario de facturación predeterminado",
        "tooltip": "Este calendario de facturación se aplicará automáticamente a un hogar o cliente si no se ha establecido ningún calendario de facturación. Solo puede haber un calendario de facturación predeterminado.",
        "defaultFlagTooltip": "Solo puede haber un calendario de facturación predeterminado activo. Elimine la marca predeterminada del calendario de facturación predeterminado activo existente."
      },
      "disclaimerPart1": "Las tarifas se calculan desde el primer hasta el último día del ciclo (mes, trimestre, etc.) y se cobran al cliente en el siguiente ciclo de facturación.",
      "disclaimerPart2": "Las tarifas correspondientes al ciclo de facturación comprendido entre el {{startDate}} y el {{endDate}} se calcularán el {{nextCalculationDate}} y se facturarán el {{nextBillingDate}}.",
      "calculationDate": "Fecha de cálculo",
      "billingDate": "Fecha de facturación",
      "calcDateMustBePastBillingDate": "La fecha de cálculo no debe ser posterior a la fecha de facturación"
    },
    "new": {
      "title": "Nuevo calendario de facturación",
      "createdToastMessage": "Se ha creado el calendario de facturación.",
      "suffix": "día del mes"
    },
    "delete": {
      "confirmationTitle": "Eliminar calendario de facturación",
      "confirmationMessage": "¿Está seguro de que desea eliminar este calendario de facturación?"
    },
    "frequencies": {
      "MONTHLY": "Mensual",
      "QUARTERLY": "Trimestral",
      "SEMESTRAL": "Semestral",
      "ANNUAL": "Anual"
    },
    "modelName": "calendario de facturación",
    "errors": {
      "noDefaultFound": "No se encontró ningún calendario de facturación predeterminado. Por favor, seleccione uno.",
      "multipleDefaultsFound": "Se encontraron varios calendarios de facturación predeterminados ({{schedule_names}}). Por favor, seleccione solo uno."
    }
  },
  "feeReport": {
    "exportTitle": "Facturación",
    "exportTypeDaily": "Diario",
    "exportTypeCycle": "Ciclo",
    "exportProgressTitle": "Exportación de facturación",
    "refreshSubAccountBillingTotals": "Actualizar totales de facturación",
    "exportHeaders": {
      "billingCycleId": "Identificador del ciclo de facturación",
      "date": "Fecha",
      "clientId": "ID de cliente",
      "clientFirstName": "Nombre del cliente",
      "clientLastName": "Apellido del cliente",
      "clientProvince": "Provincia del cliente",
      "entityName": "Nombre de la entidad del cliente",
      "accountId": "ID de cuenta",
      "accountType": "Tipo de cuenta",
      "accountNumber": "Número de cuenta",
      "subAccountId": "ID de subcuenta",
      "subAccountName": "Nombre de subcuenta",
      "goalId": "ID de la meta",
      "goalName": "Nombre de meta",
      "aum": "Activos bajo gestión facturables ($)",
      "billableAum": "Activos bajo gestión netos de reducciones ($)",
      "cash": "Efectivo ($)",
      "householdAum": "Activos bajo gestión de hogares ($)",
      "gridScopeTotalMarketValueType": "Nivel total de activos bajo gestión de la red escalonada",
      "gridScopeTotalMarketValueCents": "Cuadrícula por niveles total de activos bajo gestión ( $)",
      "annualFeeBPS": "Cuota anual BPS",
      "dailyFeeBPS": "Tarifa diaria BPS",
      "dailyFee": "Tarifa diaria ($)",
      "organizationId": "Identificación de la organización",
      "organizationName": "Nombre de la organización",
      "feePaymentAccountId": "ID de la cuenta para el pago de cuotas",
      "billingCycleState": "Estado del ciclo de facturación",
      "billingCycleStartDate": "Fecha de inicio del ciclo de facturación",
      "billingCycleEndDate": "Fecha de finalización del ciclo de facturación",
      "billingCycleSalesTax": "Impuesto sobre las ventas ($)",
      "projectedFeeAndTax": "Tasas e impuestos previstos",
      "feeGridId": "ID de la tabla de tarifas",
      "feeGridName": "Nombre de la tabla de tarifas",
      "feeTierSource": "Origen de la tabla de tarifas",
      "currency": "Moneda",
      "fxRate": "Tipo de cambio",
      "accountGroupId": "ID de grupo de cuentas",
      "accountGroupName": "Nombre del grupo de cuentas",
      "billableAumLastDayDollars": "Activos bajo gestión facturables último día ($)",
      "aumNetOfReductionsLastDayDollars": "Activos bajo gestión netos de reducciones último día ($)",
      "billingScheduleFrequency": "Frecuencia del calendario de facturación",
      "cashLastDayDollars": "Efectivo último día ($)",
      "accruedFees": "Honorarios devengados",
      "totalFeesAndTax": "Total de tasas e impuestos",
      "salesTax": "Impuesto sobre las ventas ($)",
      "gst": "GST ($)",
      "hst": "HST ($)",
      "pst": "PST ($)",
      "qst": "QST ($)",
      "portfolio": "Cartera"
    },
    "filters": {
      "billingDateFrom": "Fecha de facturación - Desde",
      "billingDateTo": "Fecha de facturación - A"
    },
    "table": {
      "client": "Cliente",
      "organization": "Organización",
      "billingSchedule": "Calendario de facturación",
      "billingDate": "Fecha de facturación",
      "feeGrid": "Tabla de tarifas",
      "from": "Desde",
      "to": "A",
      "billableAumLastDay": "Activos gestionados facturables el último día",
      "billableAumWithReductionsApplied": "Reducciones aplicadas",
      "accuredFees": "Honorarios devengados",
      "adjustedAccuredFees": "Honorarios devengados ajustados",
      "salesTax": "Impuesto sobre las ventas",
      "totalFeesAndTax": "Total de tasas e impuestos",
      "projectedFeeAndTax": "Tasas e impuestos previstos",
      "cashAvailable": "Efectivo disponible",
      "feePaymentAccount": "Cuenta de pago de tarifas",
      "currency": "Moneda",
      "refreshSubAccountBillingTotalsInfo": "La tarifa de facturación: {{feeCents}} ({{taxCents}} de impuestos) y la tarifa diaria total de facturación: {{totalDailyFeeCents}} (sin incluir impuestos) son diferentes.",
      "refreshSubAccountBillingTotalsNote": "Nota: si se ha establecido la anulación de la tarifa, es necesario desactivarla.",
      "fxRate": "Tipo de cambio",
      "accountGroup": "Grupo de cuentas"
    },
    "feeTierSource": {
      "SUB_ACCOUNT": "Subcuenta",
      "ACCOUNT": "Cuenta",
      "USER": "Cliente",
      "CLIENT_GROUP": "Hogar",
      "ORGANIZATION": "Organización",
      "PARENT_ORGANIZATION": "Organización principal"
    },
    "billingScheduleSource": {
      "SUB_ACCOUNT": "Subcuenta",
      "ACCOUNT": "Cuenta",
      "USER": "Cliente",
      "CLIENT_GROUP": "Hogar",
      "ORGANIZATION": "Organización",
      "PARENT_ORGANIZATION": "Organización principal"
    },
    "feeTierSourceFrom": "De: {{level}}",
    "billingScheduleSourceFrom": "De: {{level}}",
    "approveBillingCycleConfirmationDialog": {
      "title": "Aprobar ciclo de facturación",
      "text": "¿Está seguro de que desea aprobar el ciclo de facturación?",
      "toastMessage": "El ciclo de facturación ha sido aprobado",
      "approve": "Aprobar"
    },
    "dailyFee": {
      "feeGrid": "Tabla de tarifas: {{feeGrid}}",
      "billingDate": "Fecha de facturación: {{billingDate}}",
      "period": "Tarifas calculadas desde {{from}} hasta {{to}}",
      "date": "Fecha",
      "billableAum": "Activos bajo gestión facturables",
      "dailyFeeBps": "Tarifa diaria BPS",
      "dailyFixedFeeCents": "Tarifa fija diaria",
      "totalDailyFeeCents": "Tarifa diaria acumulada"
    },
    "overrideFees": {
      "title": "Anular tarifa fija",
      "undo": "Deshacer anulación de tarifa",
      "adjustedFeeCents": "Tarifas ajustadas",
      "adjustedSalesTaxCents": "Impuesto ajustado",
      "note": "Nota",
      "toastMessage": "Las tarifas han sido anuladas.",
      "undoMessage": "Se ha eliminado la anulación de tarifas.",
      "copyToClient": "Copiar a las notas del cliente",
      "salesTaxConfigurationError": "No se pudo cargar la configuración del impuesto sobre las ventas, por lo que no se puede calcular el impuesto ajustado. Inténtelo de nuevo más tarde."
    }
  }
}
